import { IAddFileResponse } from '../../common/repositories/encrypted-file-manager/entities/Models/AddFileResponse';
import { IDocumentFile } from '../../common/repositories/job-vacancies-backend/entities/file/DocumentFile';

export interface IMapper200 {
  statusCode: 200;
  response: IDocumentFile;
}

export const mapper200 = ({
  id,
  fileSize,
  fileType,
  fileName,
  fileHash,
  idSignature,
}: IAddFileResponse): IMapper200 => ({
  statusCode: 200,
  response: {
    id,
    size: fileSize,
    type: fileType,
    name: fileName,
    hash: fileHash as unknown as string,
    signature: idSignature as unknown as string,
  },
});
